<template>
  <div>
    <NotificationModal
      v-for="n in activeNotifications"
      :key="n.key"
      :notification="n"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useNotificationsStore } from '@notifications/stores/notificationsStore'
import NotificationModal from '@notifications/components/NotificationModal.vue'

const notificationsStore = useNotificationsStore()

const activeNotifications = computed(() =>
  Object.values(notificationsStore.notifications).filter(n => n.counter > 0)
)
</script>
